import { QueryTuple, useLazyQuery } from '@apollo/client';
import { GET_USER_BY_AUTH } from '@bechtel/client-gql';
import { User } from '@bechtel/types';
import { useEffect } from 'react';
import { EMULATED_USER_ID, HEADER_USER_ID, USER_PROJECT_ID } from '~/components/atoms/cache-keys';
import { useAppUserUpdater } from '~/components/molecules/appuser/appuser-context';
import { mockedFM } from '~/components/molecules/appuser/mock-data';
import { useEnvProvider } from '~/hooks';

export function useAuthorizeUser(): QueryTuple<{ userByAuth: User }, Record<string, any>> {
  const { envConfig } = useEnvProvider();
  const response = useLazyQuery<{ userByAuth: User }>(GET_USER_BY_AUTH, {
    notifyOnNetworkStatusChange: true,
    // fetchPolicy: 'network-only',
    //TODO: Not needed to authorise every route change. Use real time notifications to invalidate permissions
    //if the user permissions change
  });
  const { data } = response[1];
  const { userAuthorized, userNotAuthorized } = useAppUserUpdater();

  useEffect(() => {
    const user: User | undefined = data ? data.userByAuth : undefined;
    // TODO: Remove Rights functionality once RBAC is implemented in all modules
    if (user) userAuthorized({ ...user, rights: mockedFM.rights });
    else userNotAuthorized();
  }, [data, userAuthorized, userNotAuthorized]);

  useEffect(() => {
    const user: User | undefined = data ? data.userByAuth : undefined;
    if (envConfig.enableEmulation.toLowerCase() !== 'true' || !user) return;
    const emulatedUserId = window.sessionStorage.getItem(EMULATED_USER_ID) || '';
    // If emulation fails, the logged in user will be returned. Set the emulateduservalue to '' for logged in user
    if (user.bun !== emulatedUserId) window.sessionStorage.setItem(EMULATED_USER_ID, '');
  }, [data]);

  useEffect(() => {
    const user: User | undefined = data ? data.userByAuth : undefined;
    if (user && user.project && user.project.id) window.sessionStorage.setItem(USER_PROJECT_ID, user.project.id);

    if (user && user.id) window.sessionStorage.setItem(HEADER_USER_ID, user.id);
  }, [data]);

  return response;
}
